<template>
  <div>
    <v-text-field
      v-if="!hide.includes('name')"
      label="Név"
      :error-messages="errors.name"
      v-model="relay.name"
      filled
      clearable />

    <v-masked-text-field
      v-if="!hide.includes('address')"
      label="Relé cím (1-32)"
      :error-messages="errors.address"
      v-model="relay.address"
      filled
      clearable
      :mask="$config.inputMasks.createNumberMask({ min: 1, max: 32 })" />

    <v-select
      v-if="!hide.includes('operating_mode')"
      label="Működési mód"
      :error-messages="errors.operating_mode"
      v-model="relay.operating_mode"
      :items="operatingModes"
      item-text="label"
      item-value="value"
      filled
      clearable
      :value-comparator="$config.comparators.isEqual" />

    <v-textarea
      v-if="!hide.includes('comment')"
      label="Megjegyzés"
      :error-messages="errors.comment"
      v-model="relay.comment"
      filled
      auto-grow
      rows="3" />
  </div>
</template>

<script>
import { useVModels } from '@vueuse/core';

export default {
  props: {
    relay: {
      type: Object,
      default: () => ({}),
    },

    number: {
      type: Number,
    },

    errors: {
      type: Object,
      default: () => ({}),
    },

    hide: {
      type: Array,
      default: () => [],
    }
  },

  setup(props, { emit }) {
    const { relay, number } = useVModels(props, emit);

    // // Default values
    // if (relay.value.operating_mode === undefined) {
    //   relay.value.operating_mode = 0;
    // }

    // if (number.value) {
    //   relay.value.name = `Relé # ${number.value + 1}`;
    //   relay.value.address = number.value + 1;
    // }

    const operatingModes = [
      {
        label: 'Normál',
        value: 0,
      },
      {
        label: 'Fordított',
        value: 1,
      }];

    return {
      relay,
      operatingModes,
    };
  },

  watch: {
    relay: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue.operating_mode === undefined) {
          newValue.operating_mode = 0;
        }
      },
    },

    number: {
      immediate: true,
      handler(newValue, oldValue) {
        console.log(this.relay);
        if (this.relay.element_id === 0) {
          this.relay.name = `Relé #${String(newValue + 1).padStart(2, '0')}`;
          this.relay.address = newValue + 1;
        }
      }
    },
  },
};
</script>